import { MutableRefObject } from 'react';
import { AvatarDataType, MediaStatus, VideoDetailsType } from '../utils';
import { AIMedia } from './ai-generate';
import { Status } from './common';
import { IAudioCreation } from './textToSpeech';
import { Centrifuge, Subscription } from 'centrifuge';
import { UpscaleMedia } from './upscale';

export interface WebSocketSendMessage {
  event: 'register';
  data: {
    id: string;
  };
}
export interface WebSocketHookResult {
  isConnected: boolean;
  sendMessage: (data: WebSocketSendMessage) => void;
  connectionError: string | null;
  aiGenerateTaskMap: Map<string, AiGenerateTaskMap>;
  upscaleTaskMap: Map<string, UpscaleTaskMap>;
  brollCaptionTaskMap: Map<string, BrollCaptionGenerateTaskMap>;
  handleRemoveFromTaskMap: (_: { id: string; type: WebSocketDataReturnType }) => void;
  avatarCreationTaskMap: Map<string, AvatarCreationTaskMap>;
  avatarVideoTaskMap: Map<string, AvatarVideoTaskMap>;
  clonedAudioTaskMap: Map<string, ClonedAudioTaskMap>;
  socketRef: MutableRefObject<Centrifuge | null>;
  subscriptionRef: MutableRefObject<Subscription | null>;
  videoClipperTaskMap: Map<string, VideoClipperTaskMap>;
  textToSpeechTaskMap: Map<string, TextToSpeechTaskMap>;
}

export enum WebSocketDataReturnType {
  AI_GENERATE = 'aiGenerate',
  CAPTION_BROLL_GENERATE = 'captionGenerate',
  CAPTION_RENDER = 'captionRender',
  AVATAR_CREATION = 'avatarCreation',
  AVATAR_VIDEO = 'videoCreation',
  AUDIO_CLONE = 'audioClone',
  AI_HIGHLIGHT = 'aiHighlight',
  AI_BROLL_APPLY = 'aiBrollApply',
  AUDIO_BUILD = 'audioBuild',
  UPSCALE = 'upscale',
  VIDEO_CLIPPER = 'videoClipper',
  AD_EVENT = 'adEvent',
}

export interface WebsocketStatusData {
  id: string;
  progress?: number;
  status: Status;
  type: WebSocketDataReturnType;
  data?: any;
}

export interface AiGenerateTaskMap extends WebsocketStatusData {
  data?: { aiMediaData: AIMedia; errorMessage: string | null };
}

export interface UpscaleTaskMap extends WebsocketStatusData {
  data?: { upscaleData?: UpscaleMedia; errorMessage?: string | null };
}

export interface BrollCaptionGenerateTaskMap extends WebsocketStatusData {
  data?: { task: MediaStatus; renderedUrl: string };
}

export interface AvatarCreationTaskMap extends WebsocketStatusData {
  data?: { message: string; data: AvatarDataType };
}

export interface AvatarVideoTaskMap extends WebsocketStatusData {
  data?: { message: string; data: VideoDetailsType };
}

export interface ClonedAudioTaskMap extends WebsocketStatusData {
  data?: {
    createdAt: string;
    id: string;
    status: string;
    uploadId: string;
    url?: string;
    userAudioTrackId: string;
  };
}

export interface TextToSpeechTaskMap extends WebsocketStatusData {
  data?: IAudioCreation;
}

export interface VideoClipperTaskMap extends WebsocketStatusData {
  data?: { task: MediaStatus; errorMessage: string | null; data?: any };
}
